import { render } from "./WorkspaceMenu.vue?vue&type=template&id=492d5b6a"
import script from "./WorkspaceMenu.vue?vue&type=script&lang=js"
export * from "./WorkspaceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__